import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})


export class CommonService {
  public apiurl:string;

    constructor(private http: HttpClient) {   
       this.apiurl=environment.pythonUrl;
    }
    

    
    fields: any[] = [];

__fieldsAsArray(properties: any, parent: string): any[] {
    var fields: any[] = [];
    for(var field in properties){
      if((["_score", "script"].indexOf(field) === -1) && properties.hasOwnProperty(field) && !properties[field].hasOwnProperty("properties")){
        fields.push({
          'name': (parent ? (parent+"."+field): field),
          'type': properties[field]['type']
        });
      } else{
        fields = fields.concat(this.__fieldsAsArray(properties[field].properties, field));
      }
    }
    return fields;
  }
  
  __fieldsAsArray_xls(properties: any, parent: string): any[] {
    var fields: any[] = [];
    for(var field in properties){
      if((["_score", "script"].indexOf(field) === -1) && properties.hasOwnProperty(field) && !properties[field].hasOwnProperty("properties")){
        fields.push({
          'name': (parent ? (parent+"."+field): field),
          'value': properties[field]
        });
      } else{
        fields = fields.concat(this.__fieldsAsArray(properties[field].properties, field));
      }
    }
    return fields;
  }

  savefile(data){
    var tokens="JWT " + sessionStorage.getItem('token');
      var httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens})
      };
      console.log(JSON.stringify(data))
      return this.http.post(this.apiurl + '/savefile/',JSON.stringify(data), httpOptions);
  }
  stoplogstash(){
    console.log("service")
    var tokens="JWT " + sessionStorage.getItem('token');
      var httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json', 'Authorization':tokens})
      };
      return this.http.get(this.apiurl + '/stoplogstash/',httpOptions);
  }
}